import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=9d7558d6&scoped=true&"
import script from "./Shortcuts.vue?vue&type=script&lang=js&"
export * from "./Shortcuts.vue?vue&type=script&lang=js&"
import style0 from "./Shortcuts.vue?vue&type=style&index=0&id=9d7558d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7558d6",
  null
  
)

export default component.exports